import * as React from 'react';

import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'peer data-[state=checked]:bg-default-green data-[state=unchecked]:bg-grey-4 hover:data-[state=checked]:bg-secondary-green hover:data-[state=unchecked]:bg-grey-5 disabled:hover:data-[state=checked]:bg-default-green disabled:hover:data-[state=unchecked]:bg-grey-4 inline-flex h-4 w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none disabled:cursor-not-allowed disabled:opacity-60',
        className,
      )}
      {...props}>
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block size-[16px] rounded-full bg-white ring-0 drop-shadow-lg transition-transform data-[state=checked]:translate-x-[21px] data-[state=unchecked]:translate-x-[1px] dark:data-[state=unchecked]:bg-white',
        )}
      />
    </SwitchPrimitive.Root>
  );
}
export { Switch };
